"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _StylesProvider = _interopRequireDefault(require("@mui/styles/StylesProvider"));
var _colors = require("@mui/material/colors");
var theme = (0, _styles.createTheme)((0, _styles.adaptV4Theme)({
  fontSize: 10,
  spacing: 10,
  breakpoints: {
    values: {
      xxxs: 0,
      xxs: 382,
      xs: 400,
      m: 767,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1500
    }
  },
  overrides: {
    MuiGrid: {
      container: {},
      item: {}
    }
  }
}, {
  index: 1
}));
var MaterialTheme = function MaterialTheme(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_StylesProvider.default, {
    injectFirst: true
  }, _react.default.createElement(_styles.StyledEngineProvider, {
    injectFirst: true
  }, _react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, children)));
};
var _default = MaterialTheme;
exports.default = _default;